export const trainingCampaigns = [
  {
    id: "TC001",
    campaignName: "Annual Data Privacy Refresher",
    campaignType: "Mandatory",
    audience: "All Employees",
    assignedLearners: ["L001", "L002", "L003", "L004", "L005", "L006", "L007", "L008"],
    startDate: "2023-12-01",
    endDate: "2023-12-31",
    status: "Active",
    completionRate: 87,
    trainingContent: ["TM004"],
  },
  {
    id: "TC002",
    campaignName: "Phishing Fundamentals",
    campaignType: "Remedial",
    audience: "High-Risk Learners",
    assignedLearners: ["L002", "L004", "L007", "L008"],
    startDate: "2023-10-01",
    endDate: "2023-11-30",
    status: "Completed",
    completionRate: 100,
    trainingContent: ["TM001", "TM005"],
  },
  {
    id: "TC003",
    campaignName: "Secure Remote Work",
    campaignType: "Mandatory",
    audience: "Remote & Hybrid Staff",
    assignedLearners: ["L001", "L003", "L005", "L006", "L008"],
    startDate: "2024-01-01",
    endDate: "2024-01-15",
    status: "Active",
    completionRate: 24,
    trainingContent: ["TM006"],
  },
  {
    id: "TC004",
    campaignName: "New Hire Security Onboarding",
    campaignType: "Onboarding",
    audience: "New Hires",
    assignedLearners: ["L007"],
    startDate: "2024-01-10",
    endDate: "2024-01-24",
    status: "Active",
    completionRate: 0,
    trainingContent: ["TM001", "TM002", "TM003", "TM005"],
  },
  {
    id: "TC005",
    campaignName: "HIPAA Compliance Training",
    campaignType: "Compliance",
    audience: "HR & Finance",
    assignedLearners: ["L003", "L005"],
    startDate: "2023-09-01",
    endDate: "2023-09-30",
    status: "Completed",
    completionRate: 100,
    trainingContent: ["TM008"],
  },
];